"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var infoNoSavings = 'The car you have can help you get the car you want. It’s easy and all online.';
var infoDefault = 'Save more when you trade-in the car you have for the car you want. It’s easy and all online.';
var getIncentiveContent = function (amount) { return "Get $".concat(amount, " off the price of any Carvana car"); };
var getTaxSavingsContent = function (amount, state) {
    return "Save $".concat(amount, " in ").concat(state, " sales tax (estimated)");
};
var getLienDependentContent = function (_a) {
    var amount = _a.amount, lienAmount = _a.lienAmount, lienType = _a.lienType;
    var balance = amount - lienAmount;
    var totalOfferValue = Math.floor(amount - lienAmount);
    var positiveEquity = balance >= 0;
    var smallNegativeBalanceThreshold = -2500;
    if (positiveEquity) {
        return "Apply $".concat(totalOfferValue.toLocaleString(), " to your purchase for lower down and\n      monthly payments");
    }
    if (balance <= smallNegativeBalanceThreshold) {
        return "Refinance up to $2,500 of your ".concat(lienType, " balance with your purchase");
    }
    return "Refinance your remaining ".concat(lienType, " balance with your purchase");
};
var titleNoIncentive = 'Trade in to get the car you want';
var titleWithIncentive = function (totalSavings) {
    return "Trade in to save $".concat(totalSavings, " on your purchase");
};
exports.default = {
    getIncentiveContent: getIncentiveContent,
    getLienDependentContent: getLienDependentContent,
    getTaxSavingsContent: getTaxSavingsContent,
    infoDefault: infoDefault,
    infoNoSavings: infoNoSavings,
    titleNoIncentive: titleNoIncentive,
    titleWithIncentive: titleWithIncentive
};
